module.exports = __webpack_public_path__ + "media/img/frontend_application/bg-upgrade-text-ipad-db9ad512086cad67bd463a07f8af91a4.png";